// Testimonial section reviews carousel init
var reviewCarousel = document.querySelector(".TestimonialFooter__Reviews");
var flkty = new Flickity(reviewCarousel, {
  // options
  cellAlign: "left",
  contain: true,
  prevNextButtons: false,
  watchCSS: true,
  adaptiveHeight: true,
});

var productGalleryCarousel = document.querySelector(
  ".product-gallery__custom-carousel"
);
var flkty = new Flickity(productGalleryCarousel, {
  cellAlign: "left",
  contain: "true",
  prevNextButtons: true,
  pageDots: true,
  initialIndex: 1,
  adaptiveHeight: true,
});

/** Size guide popup in product page */
$(".size-guide-popup__link").on("click", function (e) {
  e.stopPropagation(); // Prevents the click event from bubbling up to the body
  $(".size-guide-image").addClass("open");
});

$(".size-guide__close").on("click", function (e) {
  e.stopPropagation(); // Prevents the click event from bubbling up to the body
  $(".size-guide-image").removeClass("open");
});

// Close the popup when clicking outside of it
$(document).on("click", function (e) {
  if (
    $(e.target).closest(".size-guide-image.open .size-guide__table").length ===
    0
  ) {
    $(".size-guide-image").removeClass("open");
  }
});

/** Preselect best sellers in chips mode */
(function () {
  function preselectBestSellers() {
    // Only run on chips mode variant pickers
    const variantPickers = document.querySelectorAll(
      "variant-picker.variant-picker--chips"
    );

    if (variantPickers.length === 0) {
      return; // No chips mode pickers, exit early
    }

    variantPickers.forEach((picker) => {
      // Get best seller mapping from data attribute or use default
      let bestSellerByOption = {};
      const mappingAttr = picker.getAttribute("data-best-seller-mapping");

      // Helper function to normalize text by removing all whitespace and handling German characters
      const normalizeText = (text) => {
        if (!text) return "";
        return text
          .toLowerCase()
          .replace(/ö/g, "o")
          .replace(/ü/g, "u")
          .replace(/ä/g, "a")
          .replace(/ß/g, "ss")
          .replace(/\s/g, "");
      };

      if (mappingAttr) {
        // Parse the mapping string (format: "OptionName:Value,OptionName:Value")
        const mappings = mappingAttr.split(",");
        mappings.forEach((mapping) => {
          const parts = mapping.split(":");
          if (parts.length === 2) {
            const optionName = parts[0].trim();
            const value = parts[1].trim();
            if (optionName && value) {
              // Store normalized versions for comparison
              const normalizedName = normalizeText(optionName);
              const normalizedValue = normalizeText(value);
              bestSellerByOption[normalizedName] = normalizedValue;
            }
          }
        });
      } else {
        // Default mapping if no data attribute (normalized)
        bestSellerByOption = {
          [normalizeText("Grösse")]: normalizeText("90cm Breite"),
          [normalizeText("Länge")]: normalizeText("200cm Länge"),
          [normalizeText("Härtegrad")]: normalizeText("H2/H3 medium-firm"),
        };
      }

      // Skip if no best sellers configured
      if (Object.keys(bestSellerByOption).length === 0) {
        return;
      }
      // Check if URL already has a variant selected
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("variant")) {
        return; // Don't override URL variant
      }

      // Wait for variant picker to be fully initialized (product loaded and default variant set)
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds max (50 * 100ms)

      const checkInterval = setInterval(() => {
        attempts++;

        // Check if picker has the selectVariant method and product is loaded
        if (typeof picker.selectVariant === "function" && picker.product) {
          // Get all option selectors with their labels to identify option names
          const optionFieldsets = Array.from(
            picker.querySelectorAll("fieldset.variant-picker__option")
          );

          // Only proceed if we have option fieldsets and they have inputs
          if (optionFieldsets.length === 0) {
            if (attempts >= maxAttempts) clearInterval(checkInterval);
            return; // Keep checking
          }

          // Check if inputs are actually available
          const hasInputs = Array.from(optionFieldsets).some((fieldset) => {
            const selector = fieldset.querySelector("[data-option-selector]");
            return (
              selector &&
              selector.querySelectorAll('input[type="radio"]').length > 0
            );
          });

          if (!hasInputs) {
            if (attempts >= maxAttempts) clearInterval(checkInterval);
            return; // Keep checking until inputs are available
          }

          clearInterval(checkInterval);

          // Wait a bit more for variant picker to finish its initial selection
          setTimeout(() => {
            const selectedByOption = {};
            let needsPreselection = false;

            // Find best seller inputs for each option using option names
            optionFieldsets.forEach((fieldset, index) => {
              const legend = fieldset.querySelector("legend");
              const optionName = legend
                ? legend.textContent.replace(":", "").trim()
                : null;
              const optionSelector = fieldset.querySelector(
                "[data-option-selector]"
              );

              if (!optionName || !optionSelector) {
                return; // Skip if we can't identify the option
              }

              // Normalize option name for comparison (remove all whitespace)
              const normalizedOptionName = normalizeText(optionName);

              // Find best seller value (case-insensitive matching with normalized text)
              let bestSellerValue = null;
              for (const [key, value] of Object.entries(bestSellerByOption)) {
                if (normalizedOptionName.toLowerCase() === key.toLowerCase()) {
                  bestSellerValue = value;
                  break;
                }
              }

              // If this option has a best seller defined, find and select it
              if (bestSellerValue) {
                const optionInputName = `option${index + 1}`;
                const inputs = optionSelector.querySelectorAll(
                  `input[type="radio"][name="${optionInputName}"]`
                );

                // Check current selection
                const currentInput = optionSelector.querySelector(
                  `input[type="radio"][name="${optionInputName}"]:checked`
                );
                const currentValue = currentInput ? currentInput.value : null;

                // Find the best seller input for this option (compare normalized values)
                for (let input of inputs) {
                  const normalizedInputValue = normalizeText(input.value);
                  if (
                    normalizedInputValue === bestSellerValue &&
                    !input.disabled
                  ) {
                    // Only select if it's not already selected
                    if (normalizeText(currentValue) !== bestSellerValue) {
                      selectedByOption[optionInputName] = input;
                      needsPreselection = true;
                    }
                    break;
                  }
                }
              }
            });

            // Select all found best seller inputs if needed
            // Works with any number of options (1, 2, 3, etc.) - doesn't require all options to have best sellers
            if (needsPreselection && Object.keys(selectedByOption).length > 0) {
              // Select all best seller inputs (can be just 1 option or multiple)
              Object.values(selectedByOption).forEach((input) => {
                input.checked = true;
                input.dispatchEvent(new Event("change", { bubbles: true }));
              });
            }
          }, 200); // Small delay to ensure variant picker has finished initialization
        } else if (attempts >= maxAttempts) {
          clearInterval(checkInterval);
        }
      }, 100);
    });
  }

  // Run on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", preselectBestSellers);
  } else {
    preselectBestSellers();
  }

  // Also run after a delay to ensure variant picker is initialized
  setTimeout(preselectBestSellers, 1000);
})();
